import React, { useState } from "react";
import { Field } from "formik";
import { Input } from "../../../../../../_metronic/_partials/controls";
import { Button, Container } from "react-bootstrap";
import axios from "axios";
import { useDispatch } from "react-redux";
import { actions } from "../../../_redux/profiles";
import { BeatLoader } from "react-spinners";
import { Alert } from "react-bootstrap";
import { Error } from "../../../../../../_metronic/_partials/controls";
import { App_Urls } from "../../../../../Urls/urlConfig";

export const UploadResumeForm = ({
  values,
  setActiveTab,
  setValues,
  resume_path,
}) => {
  // const data = {
  //   firstname: "Amit",
  //   lastname: "Kumar",
  //   phone_no: "+919079693799",
  //   email: "am.kumar0301@gmail.com",
  //   linkedin: "linkedin.com/in/amit-kumar-2b8120120",
  //   address: "J 203, Ashok Meadows, Hinjewadi, Phase-1",
  //   summary:
  //     "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by acciden",

  //   education: [
  //     {
  //       name: "B.E. IN COMPUTER SCIENCE",
  //       organization: "Army Institute of Technology, Pune University",
  //       end_date: "2017-05-01",
  //       is_current: false,
  //     },
  //     {
  //       name: "12th",
  //       organization: "Kendriya vidyalaya",
  //       end_date: "2012-01-01",
  //       is_current: false,
  //     },
  //     {
  //       name: "",
  //       organization: "Kendriya vidyalaya",
  //       end_date: "2010-01-01",
  //       is_current: false,
  //     },
  //   ],
  //   work_experience: [
  //     {
  //       job_title: "Software Developer",
  //       organization: "Josh software pvt ltd",
  //       start_date: "2017-07-01",
  //       end_date: "2020-05-01",
  //       is_current: false,
  //       description: "",
  //     },
  //     {
  //       job_title: "Applications Engineer",
  //       organization: "Dassault systems",
  //       start_date: "2020-05-01",
  //       end_date: "2023-04-20",
  //       is_current: true,
  //       description: "",
  //     },
  //   ],
  //   projects: [
  //     {
  //       description:
  //         "PROJECTS Code Curiosity Josh Software Pvt. Ltd.  4 Months This project is fully developed in ROR. It is a platform that encourages contributions to open source. Everyone is rewarded for their eforts, no matter how big or small they are. It's aim is to make open source contribution a habit!. My contribution as a developer: • Build a logic to prioritize the list of redeemer. • Modify the listing of repositories, to group all the repositories which are forked from a same parent repositories, only show parent reposi tories in the list. • Add sidekiq jobs as per the requirement. GoPay Merchant Go-Jek  6 Months This project was about building a cashless way of performing money related transactions for small/big merchants around Indonesia.It's API is in JRUBY and UI in react. It was one of the micro service in pool of micro services. My work as a developer: • Design API endpoints. • Add Models, controllers, services, jobs and migrations wherever re quired. • Integrate Amazon S3 with API app for handling files. • Add unit test cases in RSpec. MINT STAR  1YEAR, 2 Months We have developed this project for Star India. In this project we have automated the way in which the sales team details with the advertise ment agencies, shifted there work from excel sheets to our MINT(monetization Intelligence) application. My work as a developer in this project: • Initial API side application setup with Sidekiq, RSpec, FactoryBot, API documentation, Code Climate.",
  //     },
  //     {
  //       description:
  //         "PROJECTS • Authentication: Integrated app with third party authentication provider OKTA(single sign on), and setup authentication in the app without using devise. • Created controllers, models, services, upload and download scrips, wrote migrations, designed database tables. On the UI side of the project which is build in React and Redux. • AXIOS: using axios performed CRUD operations. • create components, containers, define dispatch helpers. QUICKINSURE Quickinsure  1 Year This project is already build in ruby on rails. I have given task to migrate this project UI to react and redux for making it more user friendly. My work as a developer in this project: • Initial application Setup: Defined folder structure, integrated react with redux, added dynamic routes with react router. • Added a media query to render diferent component on mobile and desktop. • Integrated it with it's API app. • create components, containers, dispatch methods as they suit the application. MEDIDATA(E-CONSENT) Dassault Systems  1 Year This project is part of a system, which provides support to about 60% of clinical trials carried out in the world as software as a service. Medi data was heavily used during clinical trials of moderna and pfizer covid 19 vaccines. I was part of a team that handle undertaking of apps that take care of onboarding of patients/participants in clinical trials. The operations were distributed across various applications(Usonia, Falling water, Broadacre, Passionfruit, Grayclif and Wingspread). I undertook the followings: • My task was to develop feature to have complete the consent pro cess of a participant without actually visiting a site. • On passionfruit side I build a feature to notify patients to complete their forms on time. • Build a feature to have video visit. So, that a participant can interact with a clinician without visiting a clinic during trials. • Build a feature to have electronic signature on the documents of the participants. • Build a service to schedule and list video visit ineractions done by the participant and clinician. • Wrote rspecs and cucumber scenarios for various features. Along with the above major feature I undertook grooming of the new developers joining the organization in ROR technology. And work on various small features came along the way.",
  //     },
  //   ],
  //   skills: [
  //     "Amazon S3",
  //     "Rspec",
  //     "Source (Game Engine)",
  //     "Sales",
  //     "Application Programming Interface (API)",
  //     "Microsoft Excel",
  //     "Github",
  //     "Sidekiq",
  //     "React Redux",
  //     "JRuby",
  //     "Cucumber (Software)",
  //     "JIRA",
  //     "Operations",
  //     "Ruby (Programming Language)",
  //     "Redis",
  //     "Curiosity",
  //     "MongoDB",
  //     "Onboarding",
  //     "Clinical Trials",
  //     "Minitest",
  //   ],
  //   certifications: ["Qualified For showcase my science"],
  // };
 
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState("");
  const handleUpload = async (values) => {
    try {
      setLoader(true);
      const formData = new FormData();
      formData.append("resume", values.resume);

      const url = App_Urls.OCR_URL;
      const response = await axios.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data) {
        const { data } = response.data;

        values = { ...values, ...data };

        const updatedValues = {
          ...values,
          skills: [{ skill_type: "", skill: values.skills.join(", ") }],
        };
        setValues(updatedValues);
        dispatch(actions.ResumeBuilder(updatedValues));
        setLoader(false);
        setActiveTab("profile");
      }
    } catch (error) {
      setLoader(false);
      setMessage(error.response.data.message);
    }
  };

  // const fetchResume = async (resume_path) => {
  //   try {
  //     const response = await axios.get(resume_path, {
  //       responseType: "blob",
  //     });
  //     return response.data;
  //   } catch (error) {
  //     console.error('Error fetching resume:', error);
  //     return null;
  //   }
  // };

  // useEffect(() => {
  //   let resumeResr=fetchResume(resume_path)
  //  console.log(resumeResr)
  // }, [])
  
 
  
 return (
    <>
      <Error message={message} />
      {loader && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            marginTop: "50px",
          }}
        >
          <h3
            style={{
              marginBottom: "20px",
              textAlign: "center",
              fontWeight: "bold",
            }}
          >
            Please Wait Processing Resume
          </h3>
          <BeatLoader size={15} color={"#0099ff"} loading={loader} />
        </div>
      )}
      {!loader && (
      //    <Formik
      //    enableReinitialize={resume_path?true:false}
      //    initialValues={values}
        
      //  >
      //   {({resetForm})=>(
        <Container>
          {show && (
            <Alert
              variant={"danger"}
              dismissible
              onClick={() => setShow(false)}
            >
              {message}
            </Alert>
          )}
          <div className="form-group row">
            <div className="col-lg-4">
              <label
                style={{
                  fontSize: "1.2rem",
                  fontWeight: "bold",
                }}
              >
                Upload Resume
              </label>
              <Field
                name="resume"
                component={Input}
                type="file"
                placeholder="Upload Resume"
                accept=".pdf,.doc"
                
              />
            </div>

            <div style={{ marginTop: "2rem", marginLeft: "2rem" }}>
              <Button
                variant="outline-success"
                size="lg"
                onClick={() => handleUpload(values)}
                disabled={!values.resume}
                style={{
                  cursor: !values.resume ? "auto" : "pointer",
                  padding: ".8rem 3rem",
                }}
              >
                upload
              </Button>
             
            </div>
          </div>
        </Container>
        // )}
        //  </Formik>
      )}
    </>
  );
};
